import React, { useState, useEffect } from "react";
import { Alert, Result } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getVerifyManualTransactionMyr,
} from "../../redux/actions/getVerifyManualTransaction";
import { postMyrFPXCreateTransaction } from "../../redux/actions/postQrInitManual";
import { Navigate, useNavigate } from "react-router";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import AlertMessageWrapper from "../../components/AlertMessageWrapper";
import ButtonWrapper from "../../components/ButtonWrapper";
import { Select } from "antd";
import SpinerIndicatorWhiteBg from "../../components/SpinerIndicatorWhiteBg";

const FpxMyrTransactionInfo = (props) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState("th");

  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  const { data: trnxCheckData, error: trnxCheckError } = useSelector(
    (state) => state.getQrManualCheckReducer
  );
  
  let redirectionUrl = location.search?.split("=")[1];

  useEffect(() => {
    dispatch(getVerifyManualTransactionMyr(params.id, params?.method || "myr", navigate));
  }, []);
  
  // ----------------CREATE THE TRANSACTION-------------
  useEffect(() => {
    if (verifyData) { 
      if (redirectionUrl !== undefined) {
        localStorage.setItem("redirectionUrl", redirectionUrl);
      }else{
        localStorage.setItem("redirectionUrl", verifyData?.redirectUrl || verifyData?.siteUrl);
      }

      if (verifyData?.payOption == "duitnowqr") {
        navigate(`/${params?.method || "myr"}/${params.id}/duitnowqr-payment-method/qr-code-info`);
      } else if (verifyData?.bypasspp === true || verifyData?.bypasspp === "true") {
        const payload = {
          transactionId: verifyData.trxRef,
          type: "fpx",
          amount: verifyData.amount,
          sessionId: verifyData.sessionToken,
          userId: verifyData.merchantId,
          buyerBankId: verifyData.clientBuyerBankId,
          fpxPaymentMethod: "CASA",
          transactionModel: verifyData.clientTransactionModel,
        };
        if (verifyData.clientBuyerEmail && verifyData.clientBuyerEmail.trim() !== "") {
          payload.buyerEmail = verifyData.clientBuyerEmail.trim();
        }
        dispatch(postMyrFPXCreateTransaction(payload, navigate, params.id));
      } else {
        navigate(`/myr/pay-with-fpx/${params.id}`);
      }
      // let myrTransactionParams = {
      //   transactionId: verifyData.trxRef,
      //   type:
      //     verifyData?.payOptions?.includes("ob-script") &&
      //     params?.method == "myr"
      //       ? "ob-script"
      //       : verifyData?.payOptions?.includes("vietqr") &&
      //         params?.method == "vnd"
      //       ? "vietqr"
      //       : "fpx",
      //   amount: parseFloat(verifyData?.amount),
      //   sessionId: verifyData.sessionToken,
      //   userId: verifyData.merchantId,
      // };

      // dispatch(
      //   postMyrCreateTransaction(
      //     myrTransactionParams,
      //     navigate,
      //     params.id,
      //     params?.method
      //   )
      // );
    }
  }, [verifyData]);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={error} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="d-flex justify-content-center align-items-center position-absolute" style={{ height: "100vh" }}>
      {/* <MainWrapper> */}
        {
          isLoading || qrInitLoading ? (
            <SpinerIndicatorWhiteBg fontSize="15px" color="#000" />
          ) : (
            errorMessage()
          )
          // <MyrSuccessScreen fontSize="15px" color="#000" />
          // navigate(`/myr/check-transaction/${params.id}`)
        }
      {/* </MainWrapper> */}
    </div>
  );
};

export default FpxMyrTransactionInfo;
